import { render } from "./ContentPage.vue?vue&type=template&id=6250e414&scoped=true"
import script from "./ContentPage.vue?vue&type=script&lang=js"
export * from "./ContentPage.vue?vue&type=script&lang=js"

import "./ContentPage.vue?vue&type=style&index=0&id=6250e414&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6250e414"

export default script